<template>
  <section class="p-2">
    <v-card>
      <!--         $route.query.name !== 'Transaction Limit' -->
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Setup Master Data Value</div>
        <div>
          <bread-crumb :bread-crumbs="['Master Data Map']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text>
        <!-- <v-btn
              depressed
              small
              class="mx-2 mt-2 px-5 text-capitalize"
              color="primary"
              @click="back()"
              outlined
            >
              <v-icon left>mdi-arrow-left</v-icon>
              Back</v-btn
            > -->
        <!-- <v-col cols="12" md="3" class="mt-1">
              <v-autocomplete
                placeholder="Parameter Values"
                dense
                outlined
                :search-input.sync="searchInput"
                @change="searchInput = ''"
                multiple
                :items="parametersdataValueList"
                v-model="parameterdetails.parameter_value"
                class="rounded"
              ></v-autocomplete>
            </v-col>
            <v-btn color="primary" class="mt-2" small @click="save()">
              + Add
            </v-btn> -->
        <!---------------------------------------- add category from the sub category end  -------------------------------->

        <!---------------------------------- Master data value table  start------------------------------------------>
        <v-data-table
          fixed-header
          height="55vh"
          :headers="headers"
          dense
          :search="search"
          class="p-1"
          :items="parameterValueList"
          :loading="isLoading"
          loading-text="Loading... Please wait"
          show-select
          :single-select="singleSelect"
          v-model="selectedData"
        >
          <template v-slot:top>
            <v-card
              class="pa-2 mt-3 mb-3 bord-color"
              elevation="0"
              rounded
              outlined
            >
              <v-sheet
                class="v-sheet--offset ms-4 pt-1 text-center"
                elevation="0"
                outlined
                width="90px"
              >
                <p class="font-weight-bold">
                  <v-icon small class="me-1" color="secondary"
                    >mdi-filter</v-icon
                  >Filters
                </p>
              </v-sheet>
              <v-form ref="Searchform" v-model="valid">
                <v-row row-gutters class="px-2">
                  <v-col cols="12" lg="2" sm="6" xs="12">
                    <v-autocomplete
                      class="rounded"
                      v-model="filterTxnType"
                      dense
                      outlined
                      placeholder="Transaction type"
                      :items="customer_Type"
                      item-text="txt"
                      item-value="val"
                    ></v-autocomplete>
                  </v-col>

                  <div class="d-flex mt-1">
                    <div>
                      <v-btn
                        depressed
                        small
                        @click="
                          getParameterValueList(
                            $route.query.id,
                            $route.query.pay_partner_id
                          )
                        "
                        class="mx-2 ms-3 primary text-capitalize"
                        >Get Results</v-btn
                      >
                    </div>
                  </div>
                </v-row>
              </v-form>
            </v-card>
            <v-btn
              color="primary"
              class="ms-3 text-capitalize"
              small
              @click="update()"
              :disabled="!showButton"
            >
              <v-icon small> mdi-content-save-edit-outline </v-icon> Update
              All</v-btn
            >
            <template>
              <v-row class="mt-1">
                <v-col cols="12" md="3" lg="3" xs="12" class="mt-3">
                  <label class="" style="font-size: 16px">
                    Master Parameter:
                    <b class="ms-3">{{ parameter }}</b></label
                  >
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="12" lg="4" xs="12">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Type here to filter the table data."
                    single-line
                    class="me-4 mx-2"
                    dense
                    clearable
                  ></v-text-field>
                </v-col>
              </v-row>
            </template>
          </template>
          <template v-slot:item.update="{ item }">
            <v-icon small color="primary" class="mr-2" @click="update(item)">
              mdi-content-save-edit-outline
            </v-icon>
          </template>
          <template v-slot:item.partner_parameter_value_code="{ item }">
            <v-text-field
              v-model="item.partner_parameter_value_code"
              class="rounded ma-1"
              dense
              outlined
              hide-details
              placeholder="Partner Code"
            ></v-text-field>
          </template>
          <template v-slot:item.partner_parameter_value="{ item }">
            <v-text-field
              v-model="item.partner_parameter_value"
              class="rounded ma-1"
              dense
              outlined
              hide-details
              placeholder="Partner Value"
            ></v-text-field>
          </template>
          <template v-slot:item.actions="{ item }">
            <div class="d-flex">
              <v-switch
                v-model="item.is_active"
                height="0px"
                color="success"
                dense
                @change="isactiveupdate(item)"
              ></v-switch>
              <!-- <v-icon small color="primary" class="mr-2" @click="editItem(item)">
                mdi-content-save-edit-outline
              </v-icon> -->
              <!-- <v-icon small color="primary" @click="deleteItem(item)">
                  mdi-trash-can-outline
                </v-icon> -->
            </div>
          </template>
        </v-data-table>
        <!---------------------------------- Master data value table  end------------------------------------------>
        <loading :active="isLoading" :opacity="0.9" color="#ff6b00" />
      </v-card-text>
    </v-card>
  </section>
</template>
<script>
import alerts from "@/mixins/alerts";
import Loading from "vue-loading-overlay";
import setupService from "@/services/SetupService/setupService.js";
import { Masterdatavalue } from "@/utils/validationCopy.js";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import {
  returnRnagemasterData,
  onnumberKeyDown,
} from "@/utils/ConstantDropdowns/masterDataRange.js";
export default {
  components: {
    BreadCrumb,
    Loading,
  },
  name: "Master Partner Value",
  mixins: [alerts],
  data() {
    return {
      ...Masterdatavalue,
      masterDataRange: returnRnagemasterData(),
      onnumberKeyDown,
      dialogDelete: false,
      isLoading: false,
      singleSelect: false,
      showfeild: true,
      search: "",
      deleteId: "",
      parametersdataValueList: [],
      updateData: null,
      parameter: "",
      searchInput: "",
      parameter_values: "",
      filterTxnType: "IND",
      customer_Type: [
        {
          txt: "Individual",
          val: "IND",
        },
        {
          txt: "Business",
          val: "BUS",
        },
      ],
      headers: [
        {
          text: "ID",
          value: "id",
          width: 130,
        },
        { text: "Txn Type", value: "txn_type" },
        { text: "Name", value: "parameter_value_name" },
        { text: "Code", value: "parameter_value_code" },
        { text: "Partner Value", value: "partner_parameter_value" },
        {
          text: "Partner Code",
          value: "partner_parameter_value_code",
          width: 150,
        },
        { text: "Update", value: "update", width: 150 },
        { text: "Descripition", value: "description" },
        { text: "Active/In-active", value: "actions", sortable: false },
      ],
      parameterValueList: [],
      selectedData: [],
      selectedPartnerValue: [],
      parameterdetails: {
        send_country_cd: this.$route.query.send_country_cd,
        map_level: "PW",
        parameter_value: [],
        parameter: this.$route.query.id,
        send_partner_id: this.$route.query.send_partner_id,
        pay_country_cd: this.$route.query.pay_country_cd,
        pay_partner_id: this.$route.query.pay_partner_id,
        branch: 0,
        partner_parameter_value: "",
        partner_parameter_value_code: "",
      },
    };
  },

  computed: {
    showButton() {
      return this.selectedData.length > 0;
    },
    formtitle() {
      return this.editedIndex === -1 ? "Add Value" : "Edit Value";
    },
  },

  watch: {
    selectedData(val) {
      console.log("Selected Data value===> ", val);
      this.showfeild = false;
    },
  },
  mounted() {
    // this.getallparametersvalue(this.$route.query.id);
    this.getParameterValueList(
      this.$route.query.id,
      this.$route.query.pay_partner_id
    );
  },

  methods: {
    async getParameterValueList(id, pay_partner_id) {
      this.isLoading = true;
      try {
        const responseData = await setupService.getMasterPwParameterList({
          paramter_id: id,
          payout_partner_id: pay_partner_id,
          txn_type: this.filterTxnType,
        });
        this.isLoading = false;
        if (responseData && responseData.data.status_code == 200) {
          this.parameterValueList = responseData.data.data[0];
          this.isLoading = false;
        }
      } catch (e) {
        console.log(e);
        this.isLoading = false;
      }
    },
    async getallparametersvalue(id) {
      this.isLoading = true;
      try {
        const responseData = await setupService.getParametersValuesUsertype({
          parameter_id: id,
          user_type: this.$route.query.txn_type,
        });
        this.isLoading = false;
        if (responseData && responseData.data.status_code == 200) {
          this.parametersdataValueList =
            responseData.data.data[0].parameter_values.map((ele) => {
              return {
                text: ele.value,
                value: ele.id,
              };
            });
          this.parameter = responseData.data.data[0].parameter_name;
        }
      } catch (e) {
        console.log(e);
        this.isLoading = false;
      }
    },

    async save() {
      console.log(this.parameterdetails);
      this.isLoading = true;
      try {
        const response = await setupService.addMasterData(
          this.parameterdetails
        );
        if (response.data.status_code == 200) {
          this.showAlertSuccess(response.data.message);
          this.getParameterValueList(
            this.$route.query.id,
            this.$route.query.pay_partner_id
          );
          this.parameterdetails.parameter_value = "";
          this.isLoading = false;
        } else {
          this.showAlertError(`Failed: ${response.data.message}`);
          this.isLoading = false;
        }
      } catch (e) {
        console.error(e);
        this.showAlertError("Something went wrong please try again later.");
        this.isLoading = false;
      }
    },
    async update(item) {
      if (item) {
        this.updateData = [
          {
            id: item.id,
            partner_parameter_value: item.partner_parameter_value,
            partner_parameter_value_code: item.partner_parameter_value_code,
          },
        ];
        this.isLoading = true;
      } else {
        if (
          this.parameterValueList.length > 0 &&
          this.selectedData.length > 0
        ) {
          this.isLoading = true;
          this.updateData = this.selectedData.map((ele) => {
            const payload = {
              id: ele.id,
              partner_parameter_value: ele.partner_parameter_value,
              partner_parameter_value_code: ele.partner_parameter_value_code,
            };
            return payload;
          });
        }
      }
      try {
        const response = await setupService.updatePwParameterList(
          this.updateData
        );
        if (response.data.status_code == 200) {
          this.showAlertSuccess(response.data.message);
          this.selectedData = [];
          this.getParameterValueList(
            this.$route.query.id,
            this.$route.query.pay_partner_id
          );
          this.isLoading = false;
        } else {
          this.showAlertError(`Failed: ${response.data.message}`);
          this.isLoading = false;
        }
      } catch (e) {
        console.error(e);
        this.showAlertError("Something went wrong please try again later.");
        this.isLoading = false;
      }
      // console.log(payload, "Payload");
    },

    deleteItem(item) {
      console.log("item", item);
      this.dialogDelete = true;
      this.deleteId = item.id;
    },

    async isactiveupdate(item) {
      item.is_active ? false : true;
      this.isLoading = true;
      try {
        const response = await setupService.updatemappingStatus({
          parameter: item.parameter,
          country: this.$route.query.send_country_cd,
          map_level: "PW",
          is_active: item.is_active,
          payout_partner_id: item.pay_partner_id,
          map_id: item.id,
        });
        if (response.data.status_code == 200) {
          this.showAlertSuccess(response.data.message);
          this.isLoading = false;
          this.getParameterValueList(
            this.$route.query.id,
            this.$route.query.pay_partner_id
          );
        } else {
          this.showAlertError(`Failed: ${response.data.message}`);
          this.isLoading = false;
        }
      } catch (e) {
        console.error(e);
        this.showAlertError("Something went wrong please try again later.");
        this.isLoading = false;
      }
    },
    back() {
      this.$router.push({
        name: "Master Data Map",
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
.required:after {
  content: " *";
  color: red;
}
label {
  font-size: 15px;
  color: black;
  margin-bottom: 0px !important;
}
.v-dialog .v-card {
  overflow: hidden !important;
}
.v-sheet--offset {
  top: -20px;
  width: 100px;
  height: 30px;
  position: relative;
  border-radius: 5px;
}
.label.v-label.theme--light {
  margin-bottom: 0px !important;
}
.v-text-field__prepend-inner {
  border-left: 1px solid #c5c5c5;
  margin-left: 8px;
  padding-left: 8px;
}
</style>
